import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SelectItem } from 'ng2-select';
import { isString, find } from 'lodash';

interface SelectValue {
  id: string,
  text: string
}


@Component({
  selector: 't-select',
  templateUrl: './select.component.html',
})
export class SelectComponent {

  @Input() items: any[] = []
  @Input() placeholder: string

  open = false
  private itemValue: any

  @Input()
  get item() {
    return this.itemValue;
  }

  @Output() itemChange = new EventEmitter();
  @Output() updated = new EventEmitter();

  set item(val) {
    this.itemValue = val;
    this.itemChange.emit(val);
  }

  selected(item: SelectItem) {
    let val = item.id;
    this.itemValue = val;
    this.itemChange.emit(val);
    this.updated.emit();
  }

  opened(val: boolean) {
    this.open = val;
  }

  get active() {
    if(!this.items) {
      return null;
    }

    if(isString(this.items[0])) {
      return [{id: this.item, text: this.item}];
    }
    else {
      let selected = find(this.items, i => i.id === this.item);

      return [selected];
    }
  }
}
